<div class="vl-card">
  <ng-content></ng-content>
</div>